import type { JoostElementIdentifier } from '@/composables/product-page/joostElements';
import ProductDescription from '@/pages/product-page/partials/product-description/ProductDescription.vue';
import ProductFaqs from '@/pages/product-page/partials/product-faqs/ProductFaqs.vue';
import ProductPriceTable from '@/pages/product-page/partials/product-price-table/ProductPriceTable.vue';
import ProductRelatedSection from '@/pages/product-page/partials/product-related/ProductRelatedSection.vue';
import ProductReviews from '@/pages/product-page/partials/product-reviews/ProductReviews.vue';
import ProductSamePrintSection from '@/pages/product-page/partials/product-same-print/ProductSamePrintSection.vue';
import type { Component } from 'vue';

/**
 * Typed as a non-partial Record so TypeScript flags a missing entry whenever an identifier is added.
 *
 * This module must only ever be imported from the product page, never from a Prismic slice —
 * SliceRegistry globs slices eagerly and is loaded by cart, checkout and every customer page.
 */
export const joostElementComponents: Record<JoostElementIdentifier, Component> = {
    PriceTable: ProductPriceTable,
    FAQs: ProductFaqs,
    SamePrintSlider: ProductSamePrintSection,
    RelatedProducts: ProductRelatedSection,
    LipscoreReviews: ProductReviews,
    ProductDescription,
};
